var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { TaskItem } from './task-item';
import { MoreDivider } from '../elements/more-divider';
import AnimateHeight from 'react-animate-height';
import { useComponentPropsFor } from '../context/component-props-context';
var cls = classNames('task-item-layout');
export var TaskItemLayoutDefaultProps = {
  items: [],
  hideContent: true
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n   \n  "], ["\n   \n  "])))
});
var WorkstreamTaskItemStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-bottom: ", ";\n\n    ", "\n\n    &:last-child {\n      margin-bottom: 0;\n      padding-bottom: 0;\n    }\n  "], ["\n    margin-bottom: ", ";\n\n    ", "\n\n    &:last-child {\n      margin-bottom: 0;\n      padding-bottom: 0;\n    }\n  "])), theme.UNIT(4), function (props) {
    return props.showDetails && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      padding-bottom: 10px;\n    "], ["\n      padding-bottom: 10px;\n    "])));
  })
});
var TasksStyles = breakpoints({
  base: css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    padding: 0;\n    position: relative;\n    line-height: 1.25em;\n    margin-top: 0;\n    top: -", ";\n    padding-top: ", ";\n    margin-left: ", ";\n    margin-bottom: -", ";\n    ", ";\n    background-position: 9px 0px;\n\n    ", "\n"], ["\n    padding: 0;\n    position: relative;\n    line-height: 1.25em;\n    margin-top: 0;\n    top: -", ";\n    padding-top: ", ";\n    margin-left: ", ";\n    margin-bottom: -", ";\n    ", ";\n    background-position: 9px 0px;\n\n    ", "\n"])), theme.UNIT(5), theme.UNIT(9), theme.UNIT(3, -1), theme.UNIT(4.5), theme.DOT_BG('v', 'line-mid', 2, 4), function (props) {
    return props.showDetails && css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n      top: 0px;\n      padding-top: ", ";\n      margin-top: ", ";\n      margin-bottom: ", ";\n      &:first-child {\n        margin-top: 0;\n        padding-top: ", ";\n\n      }\n    "], ["\n      top: 0px;\n      padding-top: ", ";\n      margin-top: ", ";\n      margin-bottom: ", ";\n      &:first-child {\n        margin-top: 0;\n        padding-top: ", ";\n\n      }\n    "])), theme.UNIT(0), theme.UNIT(6), theme.UNIT(6), theme.UNIT(6));
  })
});
var MoreStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-top: -", ";\n    margin-bottom: ", ";\n  "], ["\n    margin-top: -", ";\n    margin-bottom: ", ";\n  "])), theme.UNIT(2), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  Container: styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  TaskItem: styled(TaskItem)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), WorkstreamTaskItemStyles),
  Tasks: styled.ul(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), TasksStyles),
  More: styled(MoreDivider)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), MoreStyles)
};
export var TaskItemLayout = function (props) {
  var _a = useComponentPropsFor('TaskItemLayout', TaskItemLayoutDefaultProps, props),
    className = _a.className,
    children = _a.children,
    maxItems = _a.maxItems,
    items = _a.items,
    hideContent = _a.hideContent;
  var _b = __read(useState(!hideContent), 2),
    isExpanded = _b[0],
    setIsExpanded = _b[1];
  var itemsToShow = maxItems === 0 && !isExpanded ? [] : maxItems && !isExpanded ? items.slice(0, maxItems) : items;
  var moreCount = items.length - itemsToShow.length;
  var showMoreLink = moreCount >= 0 && items.length;
  var hasItems = !!items.length;
  return React.createElement(My.Container, {
    className: cls.name(className)
  }, React.createElement(AnimateHeight, {
    height: "auto"
  }, React.createElement(My.Tasks, {
    showDetails: true
  }, itemsToShow.map(function (task) {
    return React.createElement(My.TaskItem, {
      showDetails: true,
      entity: task,
      key: task.id
    });
  }))), hasItems && showMoreLink && React.createElement(My.More, {
    minimise: isExpanded,
    count: moreCount,
    onClick: function (event) {
      event.stopPropagation();
      setIsExpanded(function (isExpanded) {
        return !isExpanded;
      });
    }
  }), children);
};
// TaskItemLayout.defaultProps = TaskItemLayoutDefaultProps;
TaskItemLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;